import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { ReactComponent as IconLoading } from '../assets/icons/spinner.svg';
import useVersionCheck from '../hooks/useVersionCheck';

const UpdateNotification = () => {
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        // Ascolta i log della console per rilevare l'aggiornamento
        const originalLog = console.log;
        console.log = (...args) => {
            if (args[0] && args[0].includes('Nuova versione rilevata')) {
                setIsUpdating(true);
            }
            originalLog.apply(console, args);
        };

        return () => {
            console.log = originalLog;
        };
    }, []);

    // Inizializza il controllo versione
    useVersionCheck();

    return (
        <Modal
            isOpen={isUpdating}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            className="confirmation-modal"
            overlayClassName="confirmation-overlay"
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <IconLoading style={{
                    width: '40px',
                    height: '40px',
                    marginBottom: '20px'
                }} className="icon-loading" />
                <p style={{ margin: '0', fontSize: '16px', fontWeight: 'bold' }}>
                    Aggiornamento in corso...
                </p>
                <p style={{ margin: '10px 0 0', fontSize: '14px', color: '#666' }}>
                    L'app si ricaricherà automaticamente
                </p>
            </div>
        </Modal>
    );
};

export default UpdateNotification;
